
const homePage = () => {
	console.log("We're home!");
} 

